export default __webpack_public_path__ + "static/media/portfolio-22.95941c75.jpg";